export default __webpack_public_path__ + "static/media/page404.d2433a48.png";